import { render } from "./forgotPasswordVerification.vue?vue&type=template&id=4336c9f6"
import script from "./forgotPasswordVerification.vue?vue&type=script&lang=js"
export * from "./forgotPasswordVerification.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__